import { db } from "common/config/Firebase"
import BusEvent from "common/services/BusEvent"
import { calculateTotalInvoice } from "invoices/services/detail/calculateInvoicesInfo"
import updateTicketUseCase from "../updateTicketUseCase"

const ticketCollection = db.collection('tickets')
const ticketDetailCollection = db.collection('ticketDetail')

const updateTicketDetailUseCase = async (ticket, ivaPercent, detail, paymentMode, moneyToPay) => {
    const { base, total } = calculateTotalInvoice(detail.data, ivaPercent)
    const objUpdate = { basePrice: base, totalPrice: total }

    if (detail.data) {
        const description = detail.data.map(d => d.description).join('\n')
        ticket.concept = description
        await ticketCollection.doc(ticket.id).update({ concept: description })
    }
    if (paymentMode) {
        objUpdate.paymentMode = paymentMode
    }

    if (moneyToPay) {
        objUpdate.moneyToPay = moneyToPay
    }
    
    await updateTicketUseCase({ ...ticket, ...objUpdate }, ticket)

    BusEvent.publish(BusEvent.UPDATE_TICKET, { ticket: {...ticket, ...objUpdate }, oldTicket: ticket })

    await ticketDetailCollection.doc(ticket.id).set(detail)

    return {...ticket, ...objUpdate }
}

export default updateTicketDetailUseCase